import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import AuthService from '@/app-domains/user/auth/Auth.service'

import { useFlags } from 'launchdarkly-react-client-sdk'
import { InputMask } from '@/components/InputMask/InputMask'
import { Button } from '@/components/Button/Button'

import './SignIn.scoped.sass'
import ToastService from '@/components/Toast/Toast.service'
// eslint-disable-next-line
import { SocialLoginSection } from '../components/SocialLoginSection/SociaLoginSection'

export function SignIn () {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [isOnboardingActive, setIsOnboardingActive] = useState(false)
  const signInRef = useRef()
  const flags = useFlags()

  useEffect(() => {
    setIsOnboardingActive(flags.onboardingActiveClient)
  }, [flags])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const code = query?.get('code')

    if (code === 'invalid_email') {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: 'Invalid email address'
      })
    } else if (code === 'invalid_verification') {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: 'Error while setting new password'
      })
    } else if (code === 'set_password_success') {
      ToastService.show({
        type: 'success',
        title: 'Password successfully changed',
        message: 'Login with your new password!'
      })
    }
  }, [])

  // eslint-disable-next-line
  const handleEmailChange = (value) => {
    const email = value
    setEmail(email)
  }
  // eslint-disable-next-line
  const handlePassChange = (value) => {
    const password = value
    setPassword(password)
  }

  const signIn = async (email, password) => {
    if (!email || !password) {
      return ToastService.show({
        type: 'error',
        title: 'Wrong credentials',
        message: 'Password can\'t be empty'
      })
    }
    try {
      const user = await Auth.signIn(email, password)
      return user
    } catch (error) {
      return error
    }
  }

  // eslint-disable-next-line
  const onSubmitHandler = (e) => {
    setSubmitting(true)
    
    ToastService.show({
      type: 'info',
      title: 'Login',
      message: 'Login in process ...',
      duration: 2500,
    })

    signIn(email, password)
      .then((response) => {
        if (!response) {
          return
        }
        setSubmitting(false)
        if (response.username?.length > 0) {
          AuthService.setUserLogged()
          AuthService.setIntervalForCheckSession()
          history.push('/')
        }
        if (response.code !== undefined) {
          ToastService.show({
            type: 'error',
            title: 'Error',
            message: response.message,
          })
        }
      })
      .catch((err) => {
        setSubmitting(false)
        ToastService.show({
          type: 'error',
          title: 'Error',
          message: 'Unsuccessful login'
        })
        // eslint-disable-next-line
        console.dir(err)
      })
  }

  function onSubmitWithEnterKey (e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      onSubmitHandler()
    }
  }

  setTimeout(() => {
    signInRef?.current?.focus()
    signInRef?.current?.click()
  }, 1000)
  
  return (
    <div className="login-form-container">
      <div className='login-form'>
        <div className='login-heading-text'>Sign In</div>
        <div className="login-input">
          <InputMask classType='email-input' label='Enter your Boxes domain or backup email address' onInput={handleEmailChange} onKeyPress={onSubmitWithEnterKey}/>
        </div>
        <div className="login-input">
          <InputMask label='Enter your password' classType='password-input' type='password' onInput={handlePassChange} onKeyPress={onSubmitWithEnterKey}/>
        </div>
        <div className="forgot-password-link">
          <Link to={'/auth/recover'} className="onboarding-text-link">Forgot your password?</Link>
        </div>
        <div className="login-button">
          <Button content="Login" size="large" click={onSubmitHandler} disabled={submitting}/>
        </div>
        
        { isOnboardingActive && <div className="onboarding-signin-texts">
          <div className="onboarding-text">
            Don't have a boxes account yet?
          </div>
          <div className="onboarding-text">
            <Link to={'/auth/signup'} className="onboarding-text-link">Sign up here</Link> or <Link to={'/auth/signup?type=free-trial'} className="onboarding-text-link">enjoy a free trial</Link>
          </div>
        </div> }
        
        {
          /* <SocialLoginSection pageName='login'/> */
        }
      </div>
    </div>
  )
}
